<div class="map-wrapper" [attr.aria-busy]="loading">
  <div class="map-surface" [attr.inert]="loading ? '' : null">
  <div #mapContainer class="map-container"></div>

  <div class="map-controls">
    @if (drawingMode() === 'idle') {
      <button type="button" class="search-area-btn" (click)="searchArea($event)">
        {{ 'MAP_SEARCH_AREA' | translate }}
      </button>
    }
    @if (polygonEnabled) {
      <div class="polygon-controls" role="group" [attr.aria-label]="'POLYGON_DRAW' | translate">
        @if (drawingMode() === 'idle') {
          @if (activePolygon) {
            <button type="button" (click)="editArea()">
              {{ 'POLYGON_EDIT' | translate }} <i class="bi bi-pencil-fill"></i>
            </button>
          } @else {
            <button type="button" (click)="drawArea()">
              {{ 'POLYGON_DRAW' | translate }} <i class="bi bi-pencil-fill"></i>
            </button>
          }
        } @else {
          @if (drawingMode() === 'drawing') {
            <span class="bg-dark text-primary">{{ 'POLYGON_INSTRUCTIONS' | translate }}</span>
            <button type="button" (click)="finishArea()">{{ 'POLYGON_FINISH' | translate }}</button>
          } @else {
            <button type="button" (click)="applyArea()">{{ 'POLYGON_APPLY' | translate }}</button>
          }
          <!-- <button type="button" (click)="cancelArea()">{{ 'POLYGON_CANCEL' | translate }}</button> -->
        }
        @if (activePolygon || drawingMode() !== 'idle') {
          <button type="button" (click)="clearArea()">{{ 'POLYGON_CLEAR' | translate }}</button>
        }
        @if (polygonError(); as error) {
          <span role="alert">{{ error | translate }}</span>
        }
      </div>
    }
  </div>

  @if (cardData && (selectedItem() || currentGroupItem()) && !cardFor(currentGroupItem() ?? selectedItem())) {
    <div class="map-overlay" (click)="$event.stopPropagation()" aria-live="polite">
      @if (cardData.loading()) { <app-loading [height]="70" theme="light" /> }
      @if (cardData.error()) {
        <div role="alert">{{ 'POLYGON_SEARCH_FAILED' | translate }}</div>
        <button type="button" (click)="cardData.retry()">{{ 'POLYGON_RETRY' | translate }}</button>
      }
      <button type="button" class="btn btn-outline-primary bg-black" (click)="onPopupClose()">{{ 'CLOSE' | translate }}</button>
    </div>
  }
  @if (cardFor(selectedItem()); as item) {
    <div class="map-overlay">
      @if (icon === 'car') {
        <app-car-map-item [car]="item" (close)="onPopupClose()"> </app-car-map-item>
      }
      @if (icon === 'home') {
        <app-property-map-item [property]="item" (close)="onPopupClose()"> </app-property-map-item>
      }
      @if (icon === 'map-point') {
        <app-user-map-item [user]="item" (close)="onPopupClose()"> </app-user-map-item>
      }
    </div>
  }
  @if (selectedGroup().length) {
    <div class="map-overlay">
      @if (cardFor(currentGroupItem()); as item) {
        @if (selectedGroup().length > 1) {
          <div class="align-content-center d-flex justify-content-center">
            <button
              class="bi cursor-poiner text-primary bg-dark bi-caret-right-fill"
              (click)="nextItem()"
            ></button>

            <span class="px-2 bg-dark text-primary">
              {{ currentGroupIndex() + 1 }}
              /
              {{ selectedGroup().length }}
            </span>

            <button
              class="bi cursor-poiner text-primary bg-dark bi-caret-left-fill"
              (click)="previousItem()"
            ></button>
          </div>
        }

        @if (icon === 'car') {
          <app-car-map-item [car]="item" (close)="onPopupClose()"> </app-car-map-item>
        }

        @if (icon === 'home') {
          <app-property-map-item [property]="item" (close)="onPopupClose()">
          </app-property-map-item>
        }

        @if (icon === 'map-point') {
          <app-user-map-item [user]="item" (close)="onPopupClose()"> </app-user-map-item>
        }
      }
    </div>
  }
  </div>
  @if (loading) {
    <div class="map-loading-overlay" role="status" aria-live="polite"
      (pointerdown)="$event.stopPropagation()"
      (click)="$event.stopPropagation()"
      (touchmove)="$event.preventDefault(); $event.stopPropagation()"
      (wheel)="$event.preventDefault(); $event.stopPropagation()">
      <app-loading [height]="80" theme="light"></app-loading>
    </div>
  }
</div>
